import React, { Component } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import moment from 'moment';

// icons
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';

// material ui core imports
import { withStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  CircularProgress,
  Button,
  IconButton,
  Grid
} from '@material-ui/core';

// material ui pickers
import MomentUtils from '@date-io/moment';

import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import { Redirect } from "react-router-dom";

// component imports
import {
  RegularCard,
  ItemGrid,
  CustomInput,
  Editor,
  UploadButton
} from "../../components";

// action imports
import {
  loadSportsletters,
  createNewSports,
  editSports,
  deleteSports
} from './reducer/actions';

// modal header
const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    padding: 20px;
    border-bottom: 1px solid rgba(153, 153, 153, 0.7);
` // modal content
const ModalContent = styled.div`
    position: relative;
    padding: 20px 20px;
    overflow: hidden;
    padding-bottom: 20px;
    line-height: 50px;
` // modal footer
const ModalFooter = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px;
    border-top: 1px solid rgba(153, 153, 153, 0.7);
`
const customModalStyles = {
  /* modal overlay */
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(15, 102, 128, 0.5)'
    },
  /* modal content */
    content: {
        top: 'calc(50% + 30px)',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0px !important',
        width: '572px'
    }
};

// custom table cell
const CustomTableCell = withStyles(theme => ({
    head: {
        textAlign: 'center'
    },

    body: {
        fontSize: 16,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '200px',
    },
}))(TableCell);

// root, table, and row styles
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

// Look! It's Bicycle Repairman!!
// But how ?!?

// component declaration
class SportsList extends Component {
  // constructor
  constructor (props) {
      super(props);

      this.state = {
          title: '',
          subtitle: '',
          date: new Date(),
          content: '',

          showModal: false,
          isEditing: false,
          editingSports: ''
      };
  }

  // load Sports News when component is going to mount
  componentDidMount() {
      this.props.loadSportsletters();
  }

  // hide modal on successful create/edit
  _onSuccess () {
      this.setState({ showModal: false });
  }

  // hide modal and log error
  _onError (error) {
      this.setState({ showModal: false });
      console.log(error);
  }

  // delete a news item
  _onDeleteSports (id) {
      this.props.deleteSports(id, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // set a news item to be Featured or not Featured
  _onChangeFeature(n) {
    const {isFeatured = false, id} = n;
    if (isFeatured) {
       this.props.editSports(id, {...n, isFeatured: false}, ()=> null, ()=> null);
    }
    else {
      this.props.editSports(id, {...n, isFeatured: true}, ()=> null, ()=> null);
      const { allSports } = this.props;
      allSports.forEach(sports => {
        if (sports.id !== id && sports.isFeatured) {
          this.props.editSports(sports.id, {...sports, isFeatured: false}, ()=> null, ()=> null);
        }
      })
    }
  }

  // set state to the values of the selected Sports News
  initEditSports (id) {
    const { allSports } = this.props;
    const curSports = allSports.filter(sports => (sports.id === id))[0];

    this.setState({
      title: curSports.title,
      subtitle: curSports.subtitle,
      date: curSports.date,
      content: curSports.content,
      image: curSports.image || null,
      isEditing: true,
      editingSports: id,
      showModal: true
    });
  }

  // called once Edit-ing is complete
  _onEditSports (id) {
    //const { allSports } = this.props;
    //const curSports = allSports.filter(sports => (sports.id === id))[0];

    this.props.editSports(id, {
      title: this.state.title,
      subtitle: this.state.subtitle,
      date: moment(this.state.date).format(),
      image: this.state.image,
      content: this.state.content,
      id: id
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // create a new Sports News piece
  _onCreateNewSports () {
    this.props.createNewSports({
      title: this.state.title,
      subtitle: this.state.subtitle,
      date: moment(this.state.date).format(),
      content: this.state.content
    }, this._onSuccess.bind(this), this._onError.bind(this));
  }

  // show the Sports News modal
  _onShowModal () {
    this.setState({
      title: '',
      subtitle: '',
      date: new Date(),
      content: '',
      showModal: true,
      isEditing: false,
    })
  }

  // close the Sports News Modal
  _onCloseModal () {
    this.setState({ showModal: false });
  }

  // render

  render() {
    // make sure only authorized Users proceed
    // check for admin rights in general
    if (!this.props.user.hasOwnProperty('admin')) {
      return (
        <Redirect from={'sportsnews'} to={'dashboard'} key={'invalid'} />
      );
    }
    // check for rights for this page in particular
    if (!this.props.user.admin.master &&
      !this.props.user.admin.hasOwnProperty('sportsNews'))
    {
      return (
        <Redirect from={'sportsnews'} to={'dashboard'} key={'noTicket'} />
      );
    }

    const { classes, allSports, isLoading } = this.props;

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <RegularCard
          cardTitle="Sports News"
          cardSubtitle="Latest notable events for school teams"
          content={
            <Table className={classes.table}>
              {/* Top row describing contents */}
              <TableHead>
                <TableRow>
                  <CustomTableCell>#</CustomTableCell>
                  <CustomTableCell>Image</CustomTableCell>
                  <CustomTableCell>Title</CustomTableCell>
                  <CustomTableCell>SubTitle</CustomTableCell>
                  <CustomTableCell>Date</CustomTableCell>
                  {/* <CustomTableCell>Content</CustomTableCell> */}
                  <CustomTableCell>More</CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading && <TableRow><TableCell colSpan={6}>
                    <CircularProgress /> </TableCell></TableRow>
                }
                {!isLoading && !isEmpty(allSports) && allSports
                  .sort((a, b) => moment(b.date).diff(moment(a.date)))
                  .map((n, id) => {
                  return (
                    <TableRow key={id} className={classes.row}>
                      {/* map each Sports News item to a Row */}
                      <CustomTableCell component="th" scope="row">
                        {/* Position in the array */}
                        {id + 1}
                      </CustomTableCell>
                      {/* News image, if applicable */}
                      <CustomTableCell>
                        <div
                          style={{
                            width: 100,
                            height: 40,
                            backgroundColor: '#ccc',
                            backgroundImage: `url("${n.image}")`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: '50% 50%'
                          }}/>
                      </CustomTableCell>
                      {/* News title */}
                      <CustomTableCell>
                        {n.title}
                      </CustomTableCell>
                      {/* News subtitle */}
                      <CustomTableCell>
                        {n.subtitle}
                      </CustomTableCell>
                      {/* News date */}
                      <CustomTableCell>
                        {moment(n.date).format('YYYY/MM/DD')}
                      </CustomTableCell>
                      {/* Formerly Content
                      <CustomTableCell>
                        <div dangerouslySetInnerHTML={{__html: n.content}} />
                      </CustomTableCell> */}
                      {/* Icon buttons and Featured button */}
                      <CustomTableCell style={{display: 'flex'}}>
                        <Checkbox
                          style={{marginLeft: 10}}
                          checkedIcon={<FavoriteIcon />}
                          icon={<FavoriteBorderIcon />}
                          checked={n.isFeatured}
                          onChange={(e,c)=>this._onChangeFeature(n)}
                        />
                        {/* Enables Editing a news item */}
                        <IconButton tooltip="Edit sports"
                          onClick={(e) => {this.initEditSports(n.id)}}>
                          <EditIcon />
                        </IconButton>
                        {/* Enables Deleting a news item */}
                        <IconButton tooltip="Delete sports"
                          onClick={(e) => {this._onDeleteSports(n.id)}}>
                          <DeleteIcon />
                        </IconButton>
                      </CustomTableCell>
                    </TableRow>
                  );
                })}
                <TableRow>
                  {/* Add Sports News button */}
                  <TableCell colSpan={6}>
                    <Button style={{background: '#E5e5e5'}}
                      onClick={this._onShowModal.bind(this)}
                    >
                      Add Sports News
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
              {this.state.showModal &&
                <ReactModal isOpen={this.state.showModal}
                  onRequestClose={this._onCloseModal.bind(this)}
                  closeTimeoutMS={450}
                  contentLabel={this.state.isEditing ? 'Edit News' : 'Add News'}
                  ariaHideApp={false}
                  style={customModalStyles}
                >
                  <ModalHeader>
                    {this.state.isEditing ? 'Edit News' : 'Add News'}
                  </ModalHeader>
                  <ModalContent>
                    <Grid container>
                      {/* Select news date */}
                      <ItemGrid xs={6}>
                        <DatePicker
                          label={'News Date'}
                          value={this.state.date}
                          onChange={(date) => {this.setState({ date: date })}} />
                      </ItemGrid>
                      {/* Upload news image */}
                      <ItemGrid
                        xs={12}
                        sm={12}
                        md={6}
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          display: 'flex'
                        }}
                      >
                        <UploadButton
                          storage="friends"
                          value={this.state.image}
                          onUploadComplete={uri => this.setState({ image: uri })}
                        />
                      </ItemGrid>
                    </Grid>
                    <Grid container>
                      {/* News title */}
                      <ItemGrid xs={4}>
                        <CustomInput
                          labelText='Title'
                          id='title'
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            value: this.state.title,
                            onChange: (e)=>this.setState({ title: e.target.value })
                          }}
                        />
                      </ItemGrid>
                      <ItemGrid xs={8}>
                        <CustomInput
                          labelText='Sub Title'
                          id='subtitle'
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            value: this.state.subtitle,
                            onChange: (e)=>this.setState({ subtitle: e.target.value })
                          }}
                        />
                      </ItemGrid>
                    </Grid>
                    <Grid container>
                      <ItemGrid xs={12}>
                        <Editor value={this.state.content}
                          handleChange={(html) => this.setState({ content: html})}
                        />
                      </ItemGrid>
                    </Grid>
                  </ModalContent>
                  {/* Edit/Create button */}
                  <ModalFooter>
                    <Button
                      variant='raised'
                      primary={true}
                      onClick={(e) => {
                        this.state.isEditing ?
                          this._onEditSports(this.state.editingSports)
                          :
                          this._onCreateNewSports()} }
                    >
                      {this.state.isEditing ? 'Edit' : 'Create'}
                    </Button>
                    {/* Cancel button */}
                    <Button variant='raised' style={{ marginLeft: 20 }}
                      onClick={(e) => {this.setState({ isEditing: false, showModal: false })}}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </ReactModal>
              }
            </Table>
          }
        />
      </MuiPickersUtilsProvider>
    ); // end of Return
  } // end of Render
} // end of class declaration

SportsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  allSports: state.sportsReducer.sports,
  isLoading: state.sportsReducer.isLoading,
  user: state.authReducer.user,
  loggedIn: state.authReducer.loggedIn,
});

const mapDispatchToProps = {
    loadSportsletters,
    createNewSports,
    editSports,
    deleteSports
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SportsList));
